<template>
    <b-modal
        ref="modal"
        title="Aviso"
        header-bg-variant="danger"
        header-text-variant="light"
        footer-bg-variant="light"
        cancel-variant="secondary"
        cancel-title="Cancelar"
        ok-variant="danger"
        :busy="deleting"
        scrollable
        centered
        no-close-on-esc
        no-close-on-backdrop
        hide-header-close
        no-fade
        @ok.prevent="confirm"
    >
        <div class="text-center">
            Deseja realmente apagar o limite de sensor definido abaixo?
        </div>
        <b-list-group class="mt-2">
            <b-list-group-item
                class="d-flex justify-content-between align-items-center"
            >
                <strong>Sensor</strong>
                <span>{{ limit.sensor.name }}</span>
            </b-list-group-item>
            <b-list-group-item
                class="d-flex justify-content-between align-items-center"
            >
                <strong>Condição</strong>
                <span>{{ LimitConditions[limit.condition] }}</span>
            </b-list-group-item>
            <b-list-group-item
                class="d-flex justify-content-between align-items-center"
            >
                <strong>Valor</strong>
                <span>{{ format(limit.value) }}</span>
            </b-list-group-item>
            <b-list-group-item
                class="d-flex justify-content-between align-items-center"
            >
                <strong>Tipo (unidade)</strong>
                <span>{{ readingKinds[limit.sensor.kind][limit.kind] }}</span>
            </b-list-group-item>
            <b-list-group-item
                class="d-flex justify-content-between align-items-center"
            >
                <strong>Nível de alerta</strong>
                <span></span>
                <b-badge :variant="alertVariant" pill class="px-3">{{
                    AlertLevels[limit.alert_level].toUpperCase()
                }}</b-badge>
            </b-list-group-item>
        </b-list-group>
        <b-alert variant="warning" :show="true" class="mb-0 mt-3"
            >Esta operação não poderá ser desfeita.</b-alert
        >
        <template #modal-ok>
            <template v-if="deleting">
                <b-spinner small /> Apagando...
            </template>
            <template v-else>Apagar</template>
        </template>
    </b-modal>
</template>

<script>
import settingsApi from "@/modules/settings/api";
import sleep from "@/utils/sleep";

export default {
    name: "SensorLimitDeleteModal",
    inject: ["LimitConditions", "format", "AlertLevels", "getAlertVariant"],
    props: {
        source: {
            type: Number,
            required: true
        },
        readingKinds: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            deleting: false,
            limit: {
                sensor: {
                    name: "",
                    kind: 1
                },
                condition: 0,
                value: 0.0,
                kind: 0,
                alert_level: 1
            }
        };
    },
    computed: {
        alertVariant() {
            return this.getAlertVariant(this.limit.alert_level);
        }
    },
    methods: {
        show(limit) {
            this.limit = limit;
            this.$refs.modal.show();
        },
        async confirm() {
            this.deleting = true;
            await this.$nextTick();
            await sleep(1000);
            await settingsApi.sensors.deleteLimit(this.source, {
                id: this.limit.id
            });
            this.$emit("delete-limit", this.limit);
            this.$bvToast.toast("Limite apagado com sucesso.", {
                title: "Aviso",
                variant: "info",
                noCloseButton: true
            });
            this.$refs.modal.hide();
            this.deleting = false;
        }
    }
};
</script>
